import React from "react";

export default function AIDisclaimer({ children }) {
  return (
    <div
      data-testid="ai-disclaimer"
      className="mt-3 rounded border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs text-amber-700"
    >
      {children || "Sugestie generata AI. Verifica inainte de decizie."}
    </div>
  );
}
